import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { format } from 'date-fns';
import { ScheduledEvent } from 'src/app/core-module/models/Diary/scheduled-event';

@Component({
    selector: 'app-scheduled-audit',
    templateUrl: './scheduled-audit.component.html',
    styleUrl: './scheduled-audit.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ScheduledAuditComponent {

  @Input() event: ScheduledEvent;
  @Input() showDate: boolean = false;
  @Output() DeleteEvent: EventEmitter<ScheduledEvent> = new EventEmitter<ScheduledEvent>();

  public isDeleteHighlight: boolean = false;
  public showAreYouSure: boolean = false;
  
  dateHeading(): string{
    return format(this.event.AuditDate,"EEE dd LLLL");
  }

  addWarning(){
    this.isDeleteHighlight = true;
  }

  removeWarning(){
    this.isDeleteHighlight = false;
  }

  deleteEvent(){
    this.showAreYouSure = true;
    this.isDeleteHighlight = false;
  }

  actualDelete(){
    this.DeleteEvent.emit(this.event);
  }
  unDelete() {
    this.showAreYouSure = false;
  }

}
